import { getEditorState } from '~/shell/Store';
import {
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  TEXT,
  LAYOUT_COLUMNS,
  LayoutColumnsDefinition,
  GAUGE,
  AudioDefinition,
  CARD
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

const getColorByIndex = (index: number) => {
  switch (index) {
    case 0:
      return '#F53258';
    case 1:
      return '#F78837';
    case 2:
      return '#F9BF60';
    case 3:
      return '#DBF337';
    case 4:
      return '#46E275';
    default:
      return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }
};

const getEmojiById = (index: number) => {
  switch (index) {
    case 0:
      return '😡';
    case 1:
      return '😠';
    case 2:
      return '😐';
    case 3:
      return '🙂';
    case 4:
      return '😀';
    default:
      return '';
  }
};

export const getSteps = (
  items?: Array<{
    id: string;
    value: string;
    subvalue?: string;
    feedback: string;
    feedbackAudios?: AudioDefinition;
  }>
) => {
  const steps: Array<{
    id: string;
    color: string;
    value: string | number;
    label: string;
    feedback?: string;
    feedbackAudios?: AudioDefinition;
  }> = [];

  (items || []).forEach((item, index) => {
    steps.push({
      id: item.id,
      color: getColorByIndex(index),
      value: index + 1,
      label: item?.subvalue || item?.value || getEmojiById(index),
      feedback: item?.feedback,
      feedbackAudios: item?.feedbackAudios
    });
  });

  return steps;
};

export const Interactive13: Translator = sequence => {
  const backgroundItems =
    sequence && sequence?.items
      ? sequence?.items.filter(item => item.type === 'BACKGROUND')
      : false;
  const background = backgroundItems ? backgroundItems[0] : false;
  const contentEditable = getEditorState().contentEditable;

  const bgAny: any = background as any;
  const gaugeBackgroundSig =
    bgAny && Array.isArray(bgAny.pictures) && bgAny.pictures.length
      ? bgAny.pictures.map((p: any) => p.id).join('-')
      : 'no_bg';
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question': {
        const items = [
          {
            id: item.id,
            type: LAYOUT_LIST,
            values: { align: 'left' },
            items: [
              ...(contentEditable || !item.subtitle
                ? []
                : [
                    {
                      type: TEXT,
                      id: item.id + '_subtitle',
                      items: [],
                      values: {
                        value: item.subtitle,
                        variant: 'sub_heading',
                        icon: 'question'
                      }
                    }
                  ]),
              {
                type: TEXT,
                id: item.id + '_title',
                items: [],
                values: {
                  value: item.title,
                  variant: 'heading1',
                  lineHeight: '30px'
                }
              },
              {
                type: TEXT,
                id: item.id + '_body',
                items: [],
                values: {
                  value: item.body,
                  fontFamily: 'Raleway'
                }
              },
              {
                type: GAUGE,
                id: 'gauge_' + gaugeBackgroundSig,
                values: {
                  steps: getSteps(item.items as []),
                  shape: 'flat'
                },
                items: []
              }
            ]
          } as LayoutListDefinition
        ];

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (background?.pictures && background?.pictures.length == 1) {
          return {
            id: item.id,
            type: LAYOUT_LIST,
            values: {
              align: 'center'
            },
            items: [
              {
                id: 'card_' + item.id,
                type: CARD,
                values: {
                  clearStyles: 'lg',
                  height: 'auto',
                  width: '500px'
                },
                items: items
              }
            ]
          };
        } else {
          return {
            id: item.id,
            type: LAYOUT_HALF_PAGE,
            values: {
              side: 'right'
            },
            items: [
              {
                type: LAYOUT_COLUMNS,
                id: '1',
                values: {},
                items: items
              } as LayoutColumnsDefinition
            ]
          } as LayoutHalfPageDefinition;
        }
      }
      default:
        return null;
    }
  });
};
